import { FETCH_QUOTE, CHANGE_COLOR } from './types';

export const fetchQuote = () => dispatch => {

	fetch('https://talaikis.com/api/quotes/random/')
		.then(res => res.json())
		.then(quote => dispatch({
			type: FETCH_QUOTE,
			payload: quote
		}));
};

export const changeColor = () => dispatch => {
	
	const backgroundColor = [
		"antiquewhite": "#faebd7",
		"aqua": "#00ffff",
		"aquamarine": "#7fffd4",
		"beige": "#f5f5dc",
		"bisque": "#ffe4c4",
		"black": "#000000",
		"blue": "#0000ff",
		"blueviolet": "#8a2be2",
		"brown": "#a52a2a",
		"chocolate": "#d2691e",
		"burlywood": "#deb887",
		"burlywood": "#deb887",
		"cadetblue": "#5f9ea0",
		"chartreuse": "#7fff00",
		"cadetblue": "#5f9ea0",
		"chartreuse": "#7fff00",
	]; 
	
	dispatch({
		type: CHANGE_COLOR,
		payload: backgroundColor[Math.floor(Math.random() * 14)]
	});
};


